import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "clear-all-filters-button",
  class ClearAllFiltersButton extends WYATTElement {
    constructor() {
      super();

      this.SearchPage = this.closest("search-page");

      this.button = this.querySelector("button");

      this.button.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();

      this.publish(WYATT.PubSub.events.clearAllFilters);
    }
  },
);
